var Te = Object.defineProperty;
var _e = (e, t, n) => t in e ? Te(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var M = (e, t, n) => (_e(e, typeof t != "symbol" ? t + "" : t, n), n);
import { b as u, s as de, a as f, v as N, c as Ae, P as ce, r as ue, d as Ne, e as T, S as O, f as Le } from "./metricsReporter-DNUK7N1y.js";
var R = ((e) => (e[e.DomContentLoaded = 0] = "DomContentLoaded", e[e.Load = 1] = "Load", e[e.FullSnapshot = 2] = "FullSnapshot", e[e.IncrementalSnapshot = 3] = "IncrementalSnapshot", e[e.Meta = 4] = "Meta", e[e.Custom = 5] = "Custom", e[e.Plugin = 6] = "Plugin", e))(R || {});
const le = new class {
  constructor(e) {
    M(this, "awaitingResolvers", []);
    M(this, "activeCount", 0);
    this.capacity = e;
  }
  async acquire() {
    if (!(this.activeCount < this.capacity))
      return new Promise((e) => {
        this.awaitingResolvers.push(e);
      });
    this.activeCount++;
  }
  release() {
    const e = this.awaitingResolvers.shift();
    e && this.activeCount <= this.capacity ? e() : this.activeCount--;
  }
  async execute(e) {
    try {
      return await this.acquire(), await e();
    } finally {
      this.release();
    }
  }
  setLimit(e) {
    this.capacity = e;
  }
}(2), pe = async ({ apiUrl: e, surveyId: t, uploadId: n, etags: a, headers: r, responseGroupUuid: s, replayDuration: o, eventDigest: d }, i = !1) => {
  var w;
  if (!i && !n && !a)
    return void u.error("UploadErr", { isMobile: i, uploadId: n, etags: a });
  u.info("MarkUploadComplete", { surveyId: t });
  const c = await de(`${e}/sdk/1/completeSessionReplay`, { method: "POST", body: JSON.stringify({ etags: a, uploadId: n, responseGroupUuid: s, surveyId: t, replayDuration: o, eventDigest: d, userAgent: (w = window == null ? void 0 : window.navigator) == null ? void 0 : w.userAgent }), headers: r, shouldRetryRequest: !0 });
  return u.info("MarkUploadDone", { surveyId: t }), c;
}, j = (e, t) => t.some((n) => e instanceof n);
let ee, te;
const V = /* @__PURE__ */ new WeakMap(), H = /* @__PURE__ */ new WeakMap(), _ = /* @__PURE__ */ new WeakMap();
let K = { get(e, t, n) {
  if (e instanceof IDBTransaction) {
    if (t === "done")
      return V.get(e);
    if (t === "store")
      return n.objectStoreNames[1] ? void 0 : n.objectStore(n.objectStoreNames[0]);
  }
  return C(e[t]);
}, set: (e, t, n) => (e[t] = n, !0), has: (e, t) => e instanceof IDBTransaction && (t === "done" || t === "store") || t in e };
function ge(e) {
  K = e(K);
}
function Me(e) {
  return (te || (te = [IDBCursor.prototype.advance, IDBCursor.prototype.continue, IDBCursor.prototype.continuePrimaryKey])).includes(e) ? function(...t) {
    return e.apply(G(this), t), C(this.request);
  } : function(...t) {
    return C(e.apply(G(this), t));
  };
}
function Oe(e) {
  return typeof e == "function" ? Me(e) : (e instanceof IDBTransaction && function(t) {
    if (V.has(t))
      return;
    const n = new Promise((a, r) => {
      const s = () => {
        r(t.error || new DOMException("AbortError", "AbortError"));
      };
      t.oncomplete = () => {
        a();
      }, t.onerror = s, t.onabort = s;
    });
    V.set(t, n);
  }(e), j(e, ee || (ee = [IDBDatabase, IDBObjectStore, IDBIndex, IDBCursor, IDBTransaction])) ? new Proxy(e, K) : e);
}
function C(e) {
  if (e instanceof IDBRequest)
    return function(n) {
      const a = new Promise((r, s) => {
        n.onsuccess = () => {
          r(C(n.result));
        }, n.onerror = () => {
          s(n.error);
        };
      });
      return _.set(a, n), a;
    }(e);
  if (H.has(e))
    return H.get(e);
  const t = Oe(e);
  return t !== e && (H.set(e, t), _.set(t, e)), t;
}
const G = (e) => _.get(e);
function W(e, { blocked: t } = {}) {
  const n = indexedDB.deleteDatabase(e);
  return t && (n.onblocked = (a) => t(a.oldVersion, a)), C(n).then(() => {
  });
}
const He = ["get", "getKey", "getAll", "getAllKeys", "count"], Fe = ["put", "add", "delete", "clear"], F = /* @__PURE__ */ new Map();
function ne(e, t) {
  if (!(e instanceof IDBDatabase) || t in e || typeof t != "string")
    return;
  if (F.get(t))
    return F.get(t);
  const n = t.replace(/FromIndex$/, ""), a = t !== n, r = Fe.includes(n);
  if (!(n in (a ? IDBIndex : IDBObjectStore).prototype) || !r && !He.includes(n))
    return;
  const s = async function(o, ...d) {
    const i = this.transaction(o, r ? "readwrite" : "readonly");
    let c = i.store;
    return a && (c = c.index(d.shift())), (await Promise.all([c[n](...d), r && i.done]))[0];
  };
  return F.set(t, s), s;
}
ge((e) => ({ ...e, get: (t, n, a) => ne(t, n) || e.get(t, n, a), has: (t, n) => !!ne(t, n) || e.has(t, n) }));
const je = ["continue", "continuePrimaryKey", "advance"], ae = {}, $ = /* @__PURE__ */ new WeakMap(), me = /* @__PURE__ */ new WeakMap(), Ve = { get(e, t) {
  if (!je.includes(t))
    return e[t];
  let n = ae[t];
  return n || (n = ae[t] = function(...a) {
    $.set(this, me.get(this)[t](...a));
  }), n;
} };
async function* Ke(...e) {
  let t = this;
  if (t instanceof IDBCursor || (t = await t.openCursor(...e)), !t)
    return;
  const n = new Proxy(t, Ve);
  for (me.set(n, t), _.set(n, G(t)); t; )
    yield n, t = await ($.get(n) || t.continue()), $.delete(n);
}
function re(e, t) {
  return t === Symbol.asyncIterator && j(e, [IDBIndex, IDBObjectStore, IDBCursor]) || t === "iterate" && j(e, [IDBIndex, IDBObjectStore]);
}
ge((e) => ({ ...e, get: (t, n, a) => re(t, n) ? Ke : e.get(t, n, a), has: (t, n) => re(t, n) || e.has(t, n) }));
const Ge = (e) => {
  if (e instanceof Attr)
    return null;
  let t = 1;
  for (let n = e.previousSibling; n; n = n.previousSibling)
    n.nodeName === e.nodeName && ++t;
  return t;
}, we = (e) => {
  if (e === null)
    return "";
  const t = [];
  if (e instanceof Document)
    return "/";
  for (let n = e; n && !(n instanceof Document) && n !== null; n = n instanceof Attr ? n.ownerElement : n.parentElement) {
    const a = t[t.length] = { name: void 0, position: null };
    switch (n.nodeType) {
      case Node.TEXT_NODE:
        a.name = "text()";
        break;
      case Node.ATTRIBUTE_NODE:
        a.name = "@" + n.nodeName;
        break;
      case Node.PROCESSING_INSTRUCTION_NODE:
        a.name = "processing-instruction()";
        break;
      case Node.COMMENT_NODE:
        a.name = "comment()";
        break;
      case Node.ELEMENT_NODE:
        a.name = n.nodeName;
    }
    a.position = Ge(n);
  }
  return "/" + t.reverse().map((n) => n.position !== null ? `/${n.name}[${n.position}]` : `/${n.name}`).join("");
}, v = { capture: !0, passive: !0 }, We = ["a", "button", "input", "option", "li", "link"], $e = ["Escape", "Enter", "Backspace", "F5", "Tab"];
let A = !1;
const qe = ["label", "type", "role", "title", "placeholder", "errormessage", "valuetext", "href"], ze = "aria-", se = (e) => {
  var a;
  if (((a = e.tagName) == null ? void 0 : a.toLowerCase()) === "html")
    return { element: "html" };
  const t = e.textContent, n = t ? { text: t } : {};
  n.element = ((r) => {
    if (!r.tagName)
      return "No tagName";
    const s = r.getAttribute("type");
    return s ? `${s} ${r.tagName.toLowerCase()}` : r.tagName.toLowerCase();
  })(e);
  for (const r of e.attributes) {
    let s = r.name;
    const o = r.value;
    s.startsWith(ze) && (s = s.substring(5)), qe.includes(s) && (n[s] = o);
  }
  return n;
}, Je = (e) => {
  var a;
  if (!e)
    return {};
  const t = { ...se(e) }, n = e.parentElement;
  if (n && We.includes((a = n.tagName) == null ? void 0 : a.toLowerCase())) {
    const r = se(n);
    Object.assign(t, r);
  }
  return t;
}, ye = (e, t) => {
  var a;
  let n = t.target;
  t.target === ((a = window.document) == null ? void 0 : a.body) && window.Sprig.pointerDownTarget && (n = window.Sprig.pointerDownTarget), Xe({ x: t.x, y: t.y, type: e, elementAttributes: Je(n), windowHeight: window.innerHeight, windowWidth: window.innerWidth, ...n instanceof HTMLElement ? { rect: n == null ? void 0 : n.getBoundingClientRect(), xPath: we(n) } : {} });
}, fe = (e) => {
  $e.includes(e.key) && et({ key: e.key });
}, Ie = /* @__PURE__ */ ((e, t) => {
  let n;
  return (a) => {
    clearTimeout(n), n = window.setTimeout(() => e(a), t);
  };
})((e) => {
  if (!(e.target instanceof HTMLElement || e.target instanceof Document))
    return;
  let t = e.target;
  "scrollTop" in t || (t = t.documentElement), tt({ xPath: we(t), x: t.scrollLeft, y: t.scrollTop, elementAttributes: { targetScrollWidth: t.scrollWidth, targetClientWidth: t.clientWidth, targetScrollHeight: t.scrollHeight, targetClientHeight: t.clientHeight } });
}, 750), he = (oe = "left_click", (e) => ye(oe, e));
var oe;
const ve = (e) => {
  e.button === 2 && ye("right_click", e);
}, De = (e) => {
  window.Sprig && (window.Sprig.pointerDownTarget = e.target);
}, Qe = () => {
  A || (window.addEventListener("click", he, v), window.addEventListener("pointerdown", De, v), window.addEventListener("mousedown", ve, v), window.addEventListener("keydown", fe, v), window.addEventListener("scroll", Ie, v), A = !0, window.performance.getEntriesByType("navigation").map((e) => e.type).includes("reload") && Ye({ url: window.location.href, currentPageTitle: document.title }), window.performance.getEntriesByType("navigation").map((e) => e.type).includes("back_forward") && Ze({ curUrl: window.location.href, fromUrl: document.referrer, currentPageTitle: document.title }));
}, p = { isRecording: !1, scrollEventUuids: {}, stopRecording: () => {
} }, be = () => window.indexedDB && window.IDBKeyRange && window.CompressionStream, y = (() => {
  const e = f.getItem("sprig.sessionId");
  if (e)
    return u.info("SessionIDFound", { savedSessionId: e }), f.removeItem("sprig.sessionId"), e;
  const t = N();
  return u.info("GeneratedSessionID", { uuid: t }), t;
})(), q = () => {
  f.setItem("sprig.disableReplayRecording", "disabled");
}, b = () => !!f.getItem("sprig.disableReplayRecording");
window.addEventListener("beforeunload", () => {
  u.info("BeforeUnload", { sessionId: y }), f.setItem("sprig.sessionId", y);
});
const Z = (e) => e && e.trim().substring(0, 500).replace(/\s\s+/g, " ").replace(/\r?\n|\r/g, " ").substring(0, 250), D = (e, t) => {
  var n, a;
  if (!b() && p.isRecording)
    try {
      (a = (n = window.rrwebRecord) == null ? void 0 : n.addCustomEvent) == null || a.call(n, e, t);
    } catch (r) {
      L("Error recording custom event", r);
    }
}, Xe = (e) => {
  var t;
  (t = e == null ? void 0 : e.elementAttributes) != null && t.text && (e.elementAttributes.text = Z(e.elementAttributes.text)), D("Sprig_Click", e);
}, Ye = (e) => {
  D("Sprig_Refresh", e);
}, Ze = (e) => {
  e.currentPageTitle && (e.currentPageTitle = Z(e.currentPageTitle)), D("Sprig_BackForward", e);
}, et = (e) => {
  D("Sprig_Keystroke", e);
}, tt = async (e) => {
  const { x: t, xPath: n, y: a } = e, r = p.scrollEventUuids[n];
  if (r)
    return I(async () => {
      var d, i, c, w;
      const s = await l.openDB(), o = await s.get("events", r);
      if (o != null && o.event) {
        const g = JSON.parse(o.event), h = t > ((i = (d = g.data) == null ? void 0 : d.payload) == null ? void 0 : i.x), m = a > ((w = (c = g.data) == null ? void 0 : c.payload) == null ? void 0 : w.y);
        if (!h && !m)
          return null;
        h && (g.data.payload.x = t), m && (g.data.payload.y = a), g.data.payload.elementAttributes = e.elementAttributes, o.event = JSON.stringify(g), await s.put("events", o);
      } else
        D("Sprig_Scroll", e);
    }, "Error updating scroll event");
  D("Sprig_Scroll", e);
}, Se = () => {
  p.stopRecording && (p.stopRecording(), p.stopRecording = void 0), p.isRecording = !1, ["cleanupInterval", "inactivityInterval", "pendingCheckInterval"].forEach((e) => {
    p[e] && (clearInterval(p[e]), p[e] = void 0);
  }), A && (window.removeEventListener("click", he, v), window.removeEventListener("pointerdown", De, v), window.removeEventListener("mousedown", ve, v), window.removeEventListener("keydown", fe, v), window.removeEventListener("scroll", Ie, v), A = !1);
}, nt = ["did not allow mutations", "called in an invalid security context"], at = (e, t, { reportError: n = !0, extraInfo: a = {} }) => {
  if (!b() && t instanceof Error) {
    if (q(), t.name === "VersionError")
      return u.error("VersionErr", { message: e }), l.deleteDB();
    ((r) => {
      if (!r)
        return !0;
      for (const s of nt)
        if (r.toLowerCase().includes(s))
          return !1;
      return !0;
    })(t == null ? void 0 : t.message) && (n && window.UserLeap.reportError(e, t, a), l.clearAll());
  }
}, L = (e, t, { reportError: n } = { reportError: !0 }) => {
  Se(), u.error("ReplayErr", { code: t.code, name: t.name }), at(e, t, { reportError: n });
}, I = async (e, t) => {
  try {
    return await e();
  } catch (n) {
    L(t, n);
  }
};
be() && (W("replayStorage").catch(console.error), W("sprig.replay").catch(console.error));
const l = new class {
  openDB() {
    return function(e, t, { blocked: n, upgrade: a, blocking: r, terminated: s } = {}) {
      const o = indexedDB.open(e, t), d = C(o);
      return a && (o.onupgradeneeded = (i) => {
        a(C(o.result), i.oldVersion, i.newVersion, C(o.transaction), i);
      }), n && (o.onblocked = (i) => n(i.oldVersion, i.newVersion, i)), d.then((i) => {
        s && (i.onclose = () => s()), r && (i.onversionchange = (c) => r(c.oldVersion, c.newVersion, c));
      }).catch(() => {
      }), d;
    }("sprigReplay", 1, { upgrade: (e, t, n) => {
      if (n === 0 && f.setItem("sprig.pendingCount", "0"), !e.objectStoreNames.contains("events")) {
        const a = e.createObjectStore("events", { keyPath: "uuid" });
        a.createIndex("sessionId", "sessionId"), a.createIndex("timestamp", "timestamp"), a.createIndex("[sessionId+timestamp]", ["sessionId", "timestamp"]);
      }
      if (!e.objectStoreNames.contains("chunkUploads")) {
        const a = e.createObjectStore("chunkUploads", { keyPath: "uuid" });
        a.createIndex("sessionId", "sessionId"), a.createIndex("timestamp", "timestamp"), a.createIndex("[sessionId+status]", ["sessionId", "status"]), a.createIndex("[uploadId+status]", ["uploadId", "status"]), a.createIndex("[sessionId+status+uploadId]", ["sessionId", "status", "uploadId"]);
      }
      if (!e.objectStoreNames.contains("pendingCaptures")) {
        const a = e.createObjectStore("pendingCaptures", { keyPath: "uuid" });
        a.createIndex("sessionId", "sessionId"), a.createIndex("timestamp", "timestamp"), a.createIndex("[sessionId+targetTimestamp]", ["sessionId", "targetTimestamp"]);
      }
    } });
  }
  deleteDB() {
    return W("sprigReplay").catch(console.error);
  }
  async bulkAdd(e, t) {
    const n = (await this.openDB()).transaction(e, "readwrite");
    return Promise.all([...t.map((a) => n.store.add(a)), n.done]);
  }
  async clearAll() {
    const e = (await this.openDB()).transaction(["events", "chunkUploads", "pendingCaptures"], "readwrite");
    return Promise.all([e.objectStore("events").clear(), e.objectStore("chunkUploads").clear(), e.objectStore("pendingCaptures").clear()]);
  }
  async deleteBySessionId(e, t) {
    const n = IDBKeyRange.only(t), a = (await this.openDB()).transaction(e, "readwrite"), r = a.store.index("sessionId");
    for await (const s of r.iterate(n))
      await s.delete();
    await a.done;
  }
  async updatePartial(e, t, n) {
    const a = (await this.openDB()).transaction(e, "readwrite"), r = await a.store.get(t);
    r && await a.store.put({ ...r, ...n }), await a.done;
  }
  async deleteRowsBefore(e, t, n = () => !0) {
    const a = IDBKeyRange.upperBound(t, !0), r = (await this.openDB()).transaction(e, "readwrite"), s = r.store.index("timestamp");
    for await (const o of s.iterate(a))
      n(o.value) && await o.delete();
    await r.done;
  }
  async getEventsBetween(e, t = Date.now()) {
    if (e >= t)
      return Promise.resolve([]);
    const n = IDBKeyRange.bound([y, e], [y, t], !1, !0);
    return (await this.openDB()).getAllFromIndex("events", "[sessionId+timestamp]", n);
  }
  async updateEventsExpiredAt(e, t, n = 30) {
    const a = /* @__PURE__ */ new Date(), r = a.setMinutes(a.getMinutes() + (n ?? 30)), s = (await this.openDB()).transaction("events", "readwrite"), o = s.store.index("[sessionId+timestamp]"), d = IDBKeyRange.bound([y, e], [y, t], !1, !0);
    for await (const i of o.iterate(d))
      await i.update({ ...i.value, expiredAt: r });
    await s.done;
  }
  async deleteChunkUploads(e, t) {
    const n = IDBKeyRange.only([t, e]), a = (await this.openDB()).transaction("chunkUploads", "readwrite");
    let s = await a.store.index("[uploadId+status]").openCursor(n);
    for (; s; )
      s.delete(), s = await s.continue();
    await a.done;
  }
  async getChunkUploadsByStatus({ sessionId: e, status: t, uploadId: n }) {
    const a = (await this.openDB()).transaction("chunkUploads", "readonly"), r = n ? a.store.index("[uploadId+status]") : a.store.index("[sessionId+status]"), s = n ? IDBKeyRange.only([n, t]) : IDBKeyRange.only([e, t]);
    return r.getAll(s);
  }
  async getPendingCaptures(e = {}) {
    return (await (await this.openDB()).getAllFromIndex("pendingCaptures", "sessionId", y)).filter((n) => !e.beforePresent || n.targetTimestamp < Date.now()).filter((n) => !e.isBeforeType || n.captureParams.replayParams.replayDurationType === "before").filter((n) => !e.isHeatmap || (n.captureParams.isHeatmap ?? !1));
  }
  async markPendingCaptureToCanUpload(e) {
    const t = (await this.openDB()).transaction("pendingCaptures", "readwrite"), n = t.store.index("sessionId");
    for await (const a of n.iterate(y)) {
      const r = a.value;
      r.captureParams.responseGroupId === e && await a.update({ ...r, canUpload: !0 });
    }
    await t.done;
  }
  async markPendingHeatmapsReady(e) {
    if (parseInt(f.getItem("sprig.pendingCount") ?? "0") === 0)
      return null;
    const t = Date.now(), n = (await this.openDB()).transaction("pendingCaptures", "readwrite"), a = n.store.index("sessionId");
    for await (const r of a.iterate(y)) {
      const s = r.value;
      !s.captureParams.isHeatmap || e && !e.includes(s.uuid) || await r.update({ ...s, targetTimestamp: t, captureParams: { ...s.captureParams, triggerTimestamp: t, replayParams: { ...s.captureParams.replayParams, replayDurationSeconds: Math.floor((t - s.timestamp) / 1e3) } } });
    }
    await n.done;
  }
}(), Ce = async (e, t) => {
  const n = performance.now();
  let a;
  try {
    a = await e();
  } finally {
    const r = performance.now() - n;
    let s = ce[t];
    s || (s = ue(t)), s.report(r / 1e3);
  }
  return a;
}, ke = (e, t) => {
  const n = performance.now();
  try {
    e();
  } finally {
    const a = performance.now() - n;
    let r = ce[t];
    r || (r = ue(t)), r.report(a / 1e3);
  }
};
let Ee = 5e3, z = 6e4, J = 0, k, Q = !1, X = [];
const rt = (e) => {
  var t, n, a, r;
  if ((t = e.event) != null && t.includes("Sprig_Scroll")) {
    const s = (r = (a = (n = JSON.parse(e.event)) == null ? void 0 : n.data) == null ? void 0 : a.payload) == null ? void 0 : r.xPath;
    if (!s)
      return;
    p.scrollEventUuids[s] = e.uuid;
  }
  X.push(e), Q || st();
}, st = () => {
  Q = !0, setTimeout(async () => {
    if (b())
      return;
    const e = X;
    X = [], Q = !1, ke(async () => {
      await (async (t) => {
        const n = t.map((a) => ({ ...a, sessionId: a.sessionId ?? y }));
        if (n.length !== 0)
          return I(() => l.bulkAdd("events", n), "Error storing replay events");
      })(e);
    }, "sdk_replay_add_event_batch_seconds");
  }, 500);
}, ot = (e, t, n) => {
  p.cleanupInterval = window.setInterval(() => {
    const a = Date.now();
    Ce(() => I(async () => {
      b() || await Promise.all([l.deleteRowsBefore("events", a - 1e3 * e, (r) => r.expiredAt === void 0 || r.expiredAt < a - 1e3 * e), l.deleteRowsBefore("chunkUploads", a - 1e3 * t), l.deleteRowsBefore("pendingCaptures", a - 1e3 * n, (r) => !r.canUpload)]);
    }, "Error deleting table rows"), "sdk_replay_cleanup_seconds"), u.debug("CleanupComplete");
  }, 3e4);
}, it = () => {
  p.pendingCheckInterval = window.setInterval(async () => {
    I(async () => {
      await Y();
    }, "Error initiating pending captures");
  }, 5e3);
}, Y = async (e = !1) => {
  const t = parseInt(k ?? "0");
  if (t === 0)
    return;
  const n = await l.getPendingCaptures({ beforePresent: !0, isBeforeType: e }), a = await l.openDB();
  await Promise.all(n.map(async (r) => (await a.delete("pendingCaptures", r.uuid), Be(r.captureParams, r.canUpload)))), k = (t - n.length).toString(), f.setItem("sprig.pendingCount", k);
}, dt = async (e, t, n, a, r) => {
  const s = Math.min(e + r, n), o = await Ce(() => l.getEventsBetween(e, s), "sdk_replay_get_events_between_seconds");
  if (!(o != null && o.length))
    return u.debug("NoEventsFound"), { validStartFound: a, events: [] };
  if (!a) {
    u.debug("ValidStartSearch");
    let d = -1;
    return o == null || o.forEach((i, c) => {
      if (!i.isValidStart)
        return;
      const w = i.timestamp <= t;
      (d < 0 || w) && (d = c);
    }), d < 0 ? (u.debug("ValidStartNotFound"), { validStartFound: a, events: [] }) : { validStartFound: !0, events: o == null ? void 0 : o.slice(d) };
  }
  return { validStartFound: a, events: o };
}, Pe = (e) => Promise.all(e.map(async (t) => {
  const n = await (async (a) => le.execute(async () => {
    var o;
    u.info("UploadChunkStart", { chunkIndex: a.chunkIndex, surveyId: a.surveyId });
    const r = await de(a.uploadUrl, { body: a.data, method: "PUT" });
    u.http("UploadChunkEnd", { url: a.uploadUrl, method: "PUT", status_code: r.status, reason: r.statusText ?? "OK", chunkIndex: a.chunkIndex, surveyId: a.surveyId });
    const s = (o = r.headers) == null ? void 0 : o.get("ETag");
    if (!s)
      throw new Error(`Upload response did not include etag for upload ${a.uploadId}, part ${a.chunkIndex}`);
    return s;
  }))(t);
  return await l.updatePartial("chunkUploads", t.uuid, { data: null, etag: n, status: "UploadComplete" }), t.uploadId;
})), Re = async (e) => {
  const t = await l.getChunkUploadsByStatus({ status: "UploadComplete", uploadId: e });
  if (!(t != null && t.length))
    return void u.info("NoChunksForUpload", { uploadId: e });
  const n = t.reduce((s, o) => (s.find((d) => d.chunkIndex === o.chunkIndex) || s.push(o), s), []);
  n.sort((s, o) => s.chunkIndex - o.chunkIndex);
  const a = n.map((s) => ({ ETag: s.etag, PartNumber: s.chunkIndex })).filter((s) => s.ETag !== null), r = n[0];
  await pe({ apiUrl: r.apiUrl, surveyId: r.surveyId, uploadId: e, responseGroupUuid: r.responseGroupId, etags: a, headers: r.completeUploadHeaders, replayDuration: r.replayDuration }), await l.deleteChunkUploads("UploadComplete", e);
}, ct = () => {
  I(async () => {
    const e = await l.getChunkUploadsByStatus({ sessionId: y, status: "ReadyForUpload" });
    if (!(e != null && e.length))
      return;
    const t = await Pe(e);
    t != null && t.length && await Promise.all(t.map((n) => {
      if (n)
        return Re(n);
    }));
  }, "Error uploading unfinished chunks");
}, ut = async (e, t) => {
  const n = t ?? Date.now();
  return (async (a, r) => {
    const s = new TextEncoder();
    let o = null;
    const d = new CompressionStream("gzip"), i = d.writable.getWriter();
    let c = !1, w = !1, [g, h] = [0, 0], m = [];
    for (let E = a - 35e3; E < r; E += z) {
      if ({ validStartFound: w, events: m } = await dt(E, a, r, w, z), !(m != null && m.length)) {
        u.debug("NoEventsFound");
        continue;
      }
      g === 0 && (g = m[0].timestamp), h = m[m.length - 1].timestamp;
      const B = m.map((P) => P.event);
      B.push(`{"timestamp":${r}}`);
      const x = `${c ? "," : "["}${B}`, U = s.encode(x);
      ke(() => {
        i.write(U);
      }, "sdk_replay_compression_seconds"), c = !0;
    }
    if (h - g < Ee)
      return u.debug("ReplayTooShort"), null;
    const S = s.encode("]");
    return i.write(S), i.close(), o = new Uint8Array(await new Response(d.readable).arrayBuffer()), o;
  })(n - e, n);
}, ie = async (e) => {
  const { surveyId: t, responseGroupId: n, visitorId: a, apiUrl: r, completeUploadHeaders: s, replayParams: o, triggerTimestamp: d } = e, i = await ut(1e3 * o.replayDurationSeconds, d);
  if (!(i != null && i.length))
    return void u.info("FileDataEmpty", { surveyId: t });
  const c = ((g, h, m) => {
    const S = g.length, E = 1024 * h * 1024, B = Math.ceil(S / m), x = Math.max(E, B), U = [];
    let P = 0;
    for (; P < S; )
      U.push(g.slice(P, P + x)), P += x;
    return U;
  })(i, o.minimumChunkSizeMb, o.signedUrls.length), w = await Promise.all(c.map(async (g, h) => {
    const m = N(), S = { apiUrl: r, chunkIndex: h + 1, completeUploadHeaders: s, etag: null, responseGroupId: n, status: "ReadyForUpload", surveyId: t, timestamp: d, totalChunks: c.length, data: g, uploadId: o.uploadId, uploadUrl: o.signedUrls[h].url, uuid: m, visitorId: a };
    return await (await l.openDB()).add("chunkUploads", { ...S, sessionId: S.sessionId ?? y }), S;
  }));
  await (async (g, h) => {
    await Pe(h), await Promise.all(g.map((m) => Re(m)));
  })([o.uploadId], w);
}, Be = async (e, t) => {
  if (b())
    return u.debug("ReplayDisabled-ScheduleOrCapture");
  const { isHeatmap: n, isStandalone: a, replayParams: r, triggerTimestamp: s, responseGroupId: o } = e, d = async () => {
    setTimeout(() => T.removeListener(O.QuestionAnswered, d), 0), I(async () => {
      r.replayDurationType === "before" ? await ie(e) : await l.markPendingCaptureToCanUpload(o);
    }, "Error in schedule/capture callback");
  };
  I(async () => {
    if (r.replayDurationType === "after" || r.replayDurationType === "beforeAndAfter")
      return !a && !n && T.on(O.QuestionAnswered, d), void await Ue(e);
    if (a || n || t)
      await ie(e), n && lt();
    else {
      const i = 35 + r.replayDurationSeconds, c = s - 1e3 * i, w = s;
      await l.updateEventsExpiredAt(c, w, r.expirationTimeLimitMinutes), T.on(O.QuestionAnswered, d);
    }
  }, "Error in scheduling/capturing replay");
}, lt = async () => {
  parseInt(k ?? "0") || f.removeItem("sprig.isCapturingHeatmap"), f.getItem("sprig.teardownAfterCapture") && (Se(), xe(), f.removeItem("sprig.teardownAfterCapture"));
}, xe = async () => b() ? u.debug("ReplayDisabled-ClearData") : Promise.all([l.deleteBySessionId("events", y), l.deleteBySessionId("pendingCaptures", y)]).catch((e) => {
  L("Error clearing user replay data", e);
}), Ue = async (e) => {
  if (b())
    return;
  const { isHeatmap: t, surveyId: n } = e, a = await l.getPendingCaptures(), r = a == null ? void 0 : a.filter((i) => i.captureParams.surveyId === n);
  if (r != null && r.length)
    return void u.info("PendingCaptureExists", { surveyId: n });
  t && (p.isRecording && I(() => {
    var i, c;
    return (c = (i = window.rrwebRecord) == null ? void 0 : i.takeFullSnapshot) == null ? void 0 : c.call(i, !0);
  }, "Error recording full snapshot"), f.setItem("sprig.isCapturingHeatmap", "true"), J = Date.now(), p.inactivityInterval || (p.inactivityInterval = window.setInterval(() => {
    var i;
    i = J, Date.now() - i >= 3e4 && I(() => l.markPendingHeatmapsReady(), "Error in heatmap inactivity");
  }, 1e3)));
  const s = { ...e, replayParams: { ...e.replayParams } };
  e.replayParams.replayDurationType === "beforeAndAfter" && (s.replayParams.replayDurationSeconds *= 2), s.replayParams.replayDurationType = "before";
  const o = e.triggerTimestamp + 1e3 * e.replayParams.replayDurationSeconds;
  s.triggerTimestamp = o, k = (parseInt(k ?? "0") + 1).toString(), f.setItem("sprig.pendingCount", k), await (await l.openDB()).add("pendingCaptures", { canUpload: !1, captureParams: s, sessionId: y, targetTimestamp: o, timestamp: Date.now(), uuid: N() });
};
Le(Object.freeze(Object.defineProperty({ __proto__: null, RecordEvent: (e) => {
  D("Sprig_TrackEvent", e);
}, RecordPageView: (e) => {
  e.description && (e.description = Z(e.description)), D("Sprig_PageView", e);
}, RecordSurveyShown: (e) => {
  D("Sprig_ShowSurvey", e);
}, _completeSessionReplay: async ({ surveyId: e, responseGroupUuid: t, eventDigest: n, headers: a }) => {
  if (!e || !t)
    return !1;
  const r = window.UserLeap._API_URL, s = await pe({ surveyId: e, responseGroupUuid: t, eventDigest: n, apiUrl: r, headers: a }, !0);
  return !(s != null && s.error);
}, checkPendingHeatmapsUrl: () => b() ? u.debug("ReplayDisabled-PendingHeatmaps") : I(async () => {
  const e = (await l.getPendingCaptures({ isHeatmap: !0 })).map((t) => ({ eventId: t.captureParams.eventId, uuid: t.uuid })).filter(({ eventId: t }) => !Ae(t)).map(({ uuid: t }) => t);
  return u.info("PendingHeatmapsToComplete", { count: e.length }), e.length && (await l.markPendingHeatmapsReady(e), u.info("MarkedPendingHeatmapsReady")), e.length;
}, "Error marking pending heatmaps ready"), clearUserReplayData: xe, disableRecording: L, initializeReplay: async ({ maxReplayDurationSeconds: e, maxInflightRequests: t = 2, replaySettings: n, teardownAfter: a = !1 }) => {
  if (k = f.getItem("sprig.pendingCount"), !p.isRecording) {
    if (a && f.setItem("sprig.teardownAfterCapture", "true"), b())
      return u.debug("ReplayDisabled");
    if (await (async () => {
      var r;
      if (!be())
        return !0;
      if ((r = window.navigator.storage) != null && r.estimate)
        try {
          const { quota: s = 0, usage: o = 0 } = await window.navigator.storage.estimate(), d = (s - o) / 1024 ** 3;
          return u.info("Storage", { availableGb: d }), d < 0.5;
        } catch {
          return !0;
        }
      return !1;
    })())
      return u.debug("IDBNotSupported"), q();
    try {
      const r = await l.openDB();
      u.info("DBVersion", { version: r.version });
    } catch (r) {
      return u.error("ReplayOpenErr", { name: r.name }), r.name === "VersionError" && l.deleteDB(), q();
    }
    if (I(async () => {
      await Y(!0);
    }, "Error uploading ready pending captures"), !e)
      return u.debug("MissingDuration");
    u.debug("ReplayInit"), await I(async () => {
      var r;
      if (n != null && n.minDuration && (Ee = n.minDuration), n != null && n.batchDuration && (z = n.batchDuration), r = t, le.setLimit(r), ct(), ot(e + 35, 1800, e + 35), it(), !window.rrwebRecord) {
        const { record: i } = await import(
          /* webpackIgnore: true */
          /* @vite-ignore */
          window.UserLeap.replayLibraryURL ?? "https://cdn.sprig.com/dependencies/record-2.0.0-alpha.17.min.js"
        );
        window.rrwebRecord = i;
      }
      const s = window.rrwebRecord;
      if (!s)
        return u.error("RecordScriptFailed");
      let o = !0, d = 0;
      p.stopRecording = s({ checkoutEveryNms: 3e4, sampling: { input: "last", scroll: 250, media: 800 }, emit: (i, c) => {
        if (i.type === R.Custom && (J = Date.now()), b())
          return;
        if (c && i.type === R.Meta)
          d = performance.now();
        else if (c && d && i.type === R.FullSnapshot) {
          const g = performance.now() - d;
          Ne("sdk_replay_snapshot_seconds", g / 1e3);
        }
        const w = o || !!c && i.type === R.Meta;
        o = !1, rt({ uuid: N(), event: JSON.stringify(i), isValidStart: w, timestamp: Date.now() });
      }, ...n }), p.isRecording = !!p.stopRecording, p.isRecording && (T.on("survey.complete", (i) => {
        var c;
        c = { id: i, userAgent: window.navigator.userAgent }, D("Sprig_SubmitSurvey", c);
      }), Qe());
    }, "Error initializing replay");
  }
}, isReplayRecording: () => p.isRecording, scheduleCapture: Ue, scheduleOrCaptureReplay: Be, tryReplayAction: I, uploadReadyPendingCaptures: Y }, Symbol.toStringTag, { value: "Module" })));
